import { createAsyncAction, normalizeHelper } from '../../utils/asyncHelpers';
import legalEntityDocumentSchema from '../../schemas/legalEntityDocument';
import {
  legalEntityDocumentsAdd,
  legalEntityDocumentsDelete,
  legalEntityDocumentsFetch,
  legalEntityDocumentActivate,
  legalEntityDocumentDeactivate,
} from '../actionHelpers/endpoints';
import {
  ENTITY_DOCUMENT_ADD,
  ENTITY_DOCUMENT_DELETE,
  ENTITY_DOCUMENT_FETCH,
  ENTITY_DOCUMENT_ACTIVATE,
  ENTITY_DOCUMENT_DEACTIVATE,
} from '../../constants/registerActionTypes';

export const fetchLegalEntityDocuments = createAsyncAction(
  ENTITY_DOCUMENT_FETCH,
  legalEntityDocumentsFetch,
  normalizeHelper([legalEntityDocumentSchema])
);

export const addLegalEntityDocument = createAsyncAction(
  ENTITY_DOCUMENT_ADD,
  legalEntityDocumentsAdd,
  normalizeHelper(legalEntityDocumentSchema)
);

export const deleteLegalEntityDocument = createAsyncAction(
  ENTITY_DOCUMENT_DELETE,
  legalEntityDocumentsDelete
);

export const activateLegalEntityDocument = createAsyncAction(
  ENTITY_DOCUMENT_ACTIVATE,
  legalEntityDocumentActivate,
  normalizeHelper(legalEntityDocumentSchema)
);

export const deactivateLegalEntityDocument = createAsyncAction(
  ENTITY_DOCUMENT_DEACTIVATE,
  legalEntityDocumentDeactivate,
  normalizeHelper(legalEntityDocumentSchema)
);
